import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Box, Button, Grid, Typography } from '@mui/material';
import React from 'react';
import theme from 'src/darkTheme';
import ButtonCTAOnboarding from './components/ButtonCTAOnboarding';
import { CardsAssistant } from './components/CardsAssistant';
import OnboardingInput from './components/OnboardingInput';

const assistantGoals = [
  {
    title: 'Warm outreach to leads',
    description: `Send a warm, personalized message to see if they're still in the market.`,
  },
  {
    title: 'Qualify leads',
    description: `Identify the most promising leads, and skip the ones that aren't a fit.`,
  },
  {
    title: 'Keep contacts updated',
    description: `Update lead details automatically when they share new information.`,
  },
];

export const PersonalizeYourAssistant = () => {
  const [assistantName, setAssistantName] = React.useState('');
  const [assistantEmail, setAssistantEmail] = React.useState('');

  return (
    <Grid container sx={{ minHeight: '100vh' }}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          //backgroundColor: theme.palette.background.default,
          backgroundColor: '#19191C',

          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          position: 'relative',
        }}
      >
        <Box sx={{ position: 'absolute', top: 32, left: 32, zIndex: 2 }}>
          <img
            src="/icon/artwork.svg"
            alt="Oppy Logo"
            style={{ width: 80, height: 'auto' }}
          />
        </Box>
        <Box
          sx={{ width: '100%', maxWidth: 420, mx: 'auto', textAlign: 'center' }}
        >
          <Typography color="#A1A1AA" fontSize={16} mb={1} fontWeight={400}>
            2 of 4
          </Typography>
          <Typography
            color="#fff"
            fontFamily="Space Grotesk"
            fontWeight={700}
            fontSize={28}
            mb={1}
          >
            Personalize your assistant
          </Typography>
          <Typography
            color="#D1D1D6"
            fontSize={16}
            mb={4}
            width={'100%'}
            textAlign={'center'}
          >
            Name your assistant and set up their email so they're ready to help.
          </Typography>
          <Box
            sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, mb: 2 }}
          >
            <Typography
              color="#fff"
              fontWeight={400}
              fontSize={16}
              mb={0.5}
              textAlign="left"
            >
              Assistant name
            </Typography>
            <OnboardingInput
              value={assistantName}
              onChange={(e) => setAssistantName(e.target.value)}
              placeholder="Assistant name"
              variant="dark"
              margin="normal"
            />
            <Typography
              color="#fff"
              fontWeight={400}
              fontSize={16}
              mb={0.5}
              mt={2}
              textAlign="left"
            >
              Assistant email
            </Typography>
            <OnboardingInput
              value={assistantEmail}
              onChange={(e) => setAssistantEmail(e.target.value)}
              placeholder="Assistant email"
              variant="dark"
              margin="normal"
            />
          </Box>
          <ButtonCTAOnboarding
            variant="contained"
            label="Continue"
            onClick={() => {}}
          />
          <Button
            startIcon={<ArrowBackIosNewIcon sx={{ fontSize: 18 }} />}
            sx={{
              color: '#4949C8',
              fontWeight: 400,
              fontSize: 16,
              textTransform: 'none',
              mt: 2,
              alignSelf: 'center',
              background: 'none',
              boxShadow: 'none',
              fontFamily: 'Space Grotesk',
              '&:hover': { background: 'none', textDecoration: 'underline' },
            }}
            variant="text"
          >
            Back
          </Button>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: '#fafafd',
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CardsAssistant
          name={assistantName}
          email={assistantEmail}
          goals={assistantGoals}
        />
      </Grid>
    </Grid>
  );
};
